import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Table} from 'antd';
import { TableCard, } from 'components';
import { includes, number as lNumber } from 'libs';
import store from './store';
import { Action } from 'components';
import moment from "moment";

export default observer(function () {
  const [rowrecords, setrowRecords] = useState({});
  const [isdisabled, setDisabled] = useState(true)
  const [data, setData] = useState([])

  useEffect(()=>{
    setData(store.records)
  },[store.records])


  const columns = [ {
    title: '申请日期',
    align: 'center',
    width:100,
    dataIndex: 'applyDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '项目编号',
    align: 'center',
    width:200,
    ellipsis:true,
    dataIndex: 'projectNo',
  },{
    title: '客户固资编号',
    align: 'center',
    width:200,
    ellipsis:true,
    dataIndex: 'customerAssetNo',
  },{
    title: '目前对接人',
    align: 'center',
    width:200,
    ellipsis:true,
    dataIndex: 'contactPerson',
  },{
    title: '存放地点',
    align: 'center',
    width:150,
    dataIndex: 'address',
  }, {
    title: '品牌',
    align: 'center',
    width:80,
    dataIndex: 'brand',
  }, {
    title: '设备名称',
    align: 'center',
    width:200,
    ellipsis:true,
    dataIndex: 'deviceName',
  }, {
    title: '货号',
    align: 'center',
    width:80,
    dataIndex: 'factoryCode',
  },{
    title: '设备序列号',
    align: 'center',
    width:150,
    dataIndex: 'deviceSerialNo',
  }, {
    title: '入库日期',
    align: 'center',
    width:120,
    dataIndex: 'storageDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '转运日期',
    align: 'center',
    width:100,
    dataIndex: 'transportDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '接收项目编号',
    align: 'center',
    width:120,
    dataIndex: 'receivProjectNo',
    
  }, {
    title: '备注',
    width:120,
    dataIndex: 'remark',
  },{
    title: '最后操作人',
    align: 'center',
    width:120,
    dataIndex: 'updatedUserName',
  }, {
    title: '最后操作时间',
    align: 'center',
    width:150,
    ellipsis:true,
    dataIndex: 'updatedTime',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '操作',
    align: 'center',
    width:60,
    fixed: 'right',
    render: info => (
      <Action>
        <Action.Button disabled={info.addType===2} onClick={() => store.showForm(info)}><span style={{ fontSize: '12px' }}>编辑</span></Action.Button>
      </Action>
    )
  },]

  return (
    <Table
      rowKey="id"
      // rowSelection={{
      //   hideSelectAll: true,
      //   selectedRowKeys: [rowrecords.id],
      //   onSelect: (record, selected) => {
      //     setrowRecords(record);
      //     setDisabled(false);
      //     // setSelected(selected);
      //   }
      // }}
      loading={store.fetching}
      dataSource={data}
      columns={columns}
      bordered
      scroll={{ x: 100, y: 'calc(100vh - 420px)' }}
      pagination={{
        showSizeChanger: true,
        showLessItems: true,
        current: store.page,
        pageSize: store.pageSize,
        total: store.pageTotal,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['5','10', '20', '50'],
        onChange: store.pageChange
      }}
      onReload={store.fetchRecords}
    />
  )

})
